import api from '../api';

export interface PricebookSyncStatus {
  last_revision: number | null;
  last_snapshot_revision: number | null;
  running_since: string | null;
  last_success_at: string | null;
  last_error: string | null;
  last_error_at: string | null;
  table_counts: Record<string, number>;
}

export interface PricebookSyncRunResult {
  outcome: string;
  error?: string | null;
  duration_ms: number;
  [key: string]: unknown;
}

class PricebookApi {
  async getStatus(): Promise<PricebookSyncStatus> {
    const response = await api.get('/pricebook/status');
    return response.data;
  }

  async syncNow(): Promise<PricebookSyncRunResult> {
    const response = await api.post('/pricebook/sync-now');
    return response.data;
  }

  async forceFullResync(): Promise<PricebookSyncRunResult> {
    const response = await api.post('/pricebook/force-full-resync');
    return response.data;
  }
}

export const pricebookApi = new PricebookApi();
